import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  return (
    <div className="mt-6 md:mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-6">
      <div className="flex items-center gap-2">
        <Icon name="Shield" size={16} style={{ color: 'var(--color-primary)' }} />
        <span className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
          Secure Login
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Icon name="Lock" size={16} style={{ color: 'var(--color-primary)' }} />
        <span className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
          Encrypted
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Icon name="CheckCircle" size={16} style={{ color: 'var(--color-primary)' }} />
        <span className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
          Verified
        </span>
      </div>
    </div>
  );
};

export default SecurityBadges;